import React from 'react';

import Button from '@material-ui/core/Button';

import { useStyles } from './styles';

const TextIconButton = ({ text, icon, click }) => {
  const classes = useStyles();

  return (
    <Button startIcon={icon} classes={classes} onClick={click}>
      {text}
    </Button>
  );
};

export default TextIconButton;
